document.addEventListener('DOMContentLoaded', () => {
  const detailsList = Array.from(document.querySelectorAll('.template-page-faq details'));
  if (!detailsList.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const EASING = 'cubic-bezier(0.16, 1, 0.3, 1)';
  const OPEN_DURATION = 420;
  const CLOSE_DURATION = 320;
  const activeAnimations = new WeakMap();

  const getSummary = (detail) => detail.querySelector('summary');
  const getContent = (detail) => detail.querySelector('.accordion__content');

  const setExpandedState = (detail, expanded) => {
    const summary = getSummary(detail);
    if (summary) summary.setAttribute('aria-expanded', String(expanded));
  };

  const cancelAnimation = (detail) => {
    const running = activeAnimations.get(detail);
    if (!running) return;

    running.heightAnimation?.cancel();
    running.contentAnimation?.cancel();
    activeAnimations.delete(detail);

    detail.classList.remove('is-animating');
    detail.style.height = '';
    detail.style.overflow = '';
  };

  const animateDetail = (detail, expand) => {
    const summary = getSummary(detail);
    const content = getContent(detail);
    if (!summary || !content) {
      detail.open = expand;
      setExpandedState(detail, expand);
      return Promise.resolve();
    }

    if (reducedMotion.matches) {
      detail.open = expand;
      setExpandedState(detail, expand);
      return Promise.resolve();
    }

    cancelAnimation(detail);

    if (expand && detail.open) return Promise.resolve();
    if (!expand && !detail.open) return Promise.resolve();

    const startHeight = detail.offsetHeight;
    if (expand) detail.open = true;
    const endHeight = expand ? summary.offsetHeight + content.offsetHeight : summary.offsetHeight;

    detail.classList.add('is-animating');
    detail.style.height = `${startHeight}px`;
    detail.style.overflow = 'hidden';

    const heightAnimation = detail.animate(
      [{height: `${startHeight}px`}, {height: `${endHeight}px`}],
      {
        duration: expand ? OPEN_DURATION : CLOSE_DURATION,
        easing: EASING,
        fill: 'forwards',
      },
    );

    const contentAnimation = content.animate(
      expand
        ? [
            {opacity: 0, transform: 'translateY(-1.2rem)', filter: 'blur(3px)'},
            {opacity: 1, transform: 'translateY(0)', filter: 'blur(0)'},
          ]
        : [
            {opacity: 1, transform: 'translateY(0)', filter: 'blur(0)'},
            {opacity: 0, transform: 'translateY(-0.8rem)', filter: 'blur(2px)'},
          ],
      {
        duration: expand ? OPEN_DURATION : CLOSE_DURATION,
        easing: EASING,
        fill: 'forwards',
      },
    );

    activeAnimations.set(detail, {heightAnimation, contentAnimation});

    return Promise.allSettled([heightAnimation.finished, contentAnimation.finished]).then(() => {
      if (!expand) detail.open = false;

      setExpandedState(detail, expand);
      detail.classList.remove('is-animating');
      detail.style.height = '';
      detail.style.overflow = '';
      activeAnimations.delete(detail);
    });
  };

  detailsList.forEach((detail) => {
    const summary = getSummary(detail);
    if (!summary) return;

    summary.addEventListener('click', async (event) => {
      event.preventDefault();

      const shouldOpen = !detail.open;
      const animations = [];

      if (shouldOpen) {
        detailsList.forEach((otherDetail) => {
          if (otherDetail !== detail && otherDetail.open) {
            animations.push(animateDetail(otherDetail, false));
          }
        });
      }

      animations.push(animateDetail(detail, shouldOpen));
      await Promise.allSettled(animations);
    });
  });
});
